<template>
  <div class="memberItem" v-for="(item, index) in members" @click="toDetails(item)">

    <div class="img">
      <img :src="showUploadImg + item.img" alt="" class="image">
    </div>
    <div class="info">
      <p class="name"><strong>{{lang === 'zh' ? item.name : item.nameEn}}</strong></p>
      <p class="position">{{lang === 'zh' ? item.position : item.positionEn}}</p>
    </div>

  </div>
</template>

<script>
  import { ref, reactive, onMounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router';
  import { useStore, mapGetters } from 'vuex'
  import bus from 'vue3-eventbus'  //引入事件总线

  export default {
    name: "MemberItem",
    props:{
      members: {
        type: Array,
        default: [],
      }
    },
    computed: {
      ...mapGetters(['showLang','showUploadImg'])
    },//computed
    setup(props,context){


      const route = useRoute()
      const router = useRouter()

      const store = useStore()
      let lang = ref('')
      lang.value = store.state.language;
      //监听事件总线
      bus.on('changeLang', type => lang.value = type);

      // 跳转到详细页
      function toDetails(detail) {
        router.push('/memberDetails/' + encodeURIComponent(JSON.stringify(detail)))
        /*router.push({
          name: '/researchDetails',
          query: { research: detail }
        })*/
      }


      return{ lang,
        toDetails,
      }
    },//setup
  }
</script>

<style scoped lang="less">

  .memberItem{
    padding: 0 25px 50px 25px;
    width: 200px;
    height: 360px; /*333*/
    //float: left;
    display: inline-block;
    transition: all 0.3s;
    cursor: pointer;
    .img{
      width: 200px;
      height: 280px;
      img{
        height: 100%;
        width: 100%;
      }
    }

    .info{
      margin-top: 16px;
      width: 200px;
      .name{
        font-size: 14px;
        color: #333;
        line-height: 1.5;
        margin-bottom: 5px;
        overflow: hidden;
        transition: all 0.3s;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 700;
        text-align: center;
      }
      .position{
        font-size: 14px;
        color: #333;
        line-height: 1.5;
        height: 1.2rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align: center;
      }
    }

  }

</style>